import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _pick from "lodash/pick";
import React from 'react';
import HtmlToNds, { NDSLib } from '@nerdwallet/react-html-to-nds';
import { Link } from '@nerdwallet/currency';
/**
 * Mappings that represent the html that we allow from custom content
 */

var HTML_WHITELIST = _objectSpread({}, _pick(NDSLib, 'a', // anchor
'b', // bold
'br', // break
'i', // italic
'li', // list item
'ol', // ordered list
'p', // paragraph
'ul', // unordered list
'&reg;', // ®
'&copy;' // ©
)); // for allowing http links


var UNSAFE_ANCHOR_TRANSFORM = function UNSAFE_ANCHOR_TRANSFORM(node, children) {
  return /*#__PURE__*/React.createElement(Link, _extends({
    rel: "noopener noreferrer"
  }, _pick(node.attribs, ['href', 'title', 'target'])), children);
};

var ContentSanitizer = function ContentSanitizer(_ref) {
  var html = _ref.html,
      respectUnsafeHref = _ref.respectUnsafeHref;

  var htmlWhitelist = _objectSpread({}, HTML_WHITELIST);

  if (!html) {
    return null;
  }

  if (respectUnsafeHref) {
    htmlWhitelist.a = UNSAFE_ANCHOR_TRANSFORM;
  }

  return /*#__PURE__*/React.createElement(HtmlToNds, {
    html: html,
    componentDict: htmlWhitelist,
    forceWhitelist: true
  });
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  ContentSanitizer.propTypes = {
    html: PropTypes.string,
    respectUnsafeHref: PropTypes.bool
  };
}

ContentSanitizer.defaultProps = {
  html: '',
  respectUnsafeHref: false
};
export default ContentSanitizer;